export const yupValidator = (schema, getFieldsValue) => {
  return function validator(field) {
    if (!field) return schema.validateSync(getFieldsValue(true), {
      abortEarly: false
    })
    return schema.validateSyncAt(field, getFieldsValue(true), {
      abortEarly: false
    });
  }
};